export class FPPError extends Error {
    /** error code given as mfShorty_errorSerial  */
    errorCode: string;
    errorTraceId: string;
    plainMessage: string;
    httpStatusCode?: number;

    constructor(message: string, errorCode: string, errorTraceId: string, stack?: string) {
        super(`[${errorTraceId}]: ${message}`);

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        //eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, FPPError);
        }

        if (stack) {
            this.stack = stack;
        }

        this.name = "FPPError";
        this.plainMessage = message;
        this.errorCode = errorCode;
        this.errorTraceId = errorTraceId;
    }
}
